import { Directive, HostListener, Input, ElementRef, OnInit, EventEmitter, Output } from '@angular/core';

const placeholders = {
  'A': '^[a-zA-ZA-zА-z]',
  '0': '\\d'
};


interface IState {
  value: string;
}

@Directive({
  selector: '[trInputMask]'
})
export class InputMaskDirective implements OnInit {
  private state: IState;

  @Input() trInputMask: any;
  @Output() ngModelChange = new EventEmitter();

  constructor(private element: ElementRef) {
    this.state = {
      value: this.getValue()
    };
  }

  /**
   *
   */
  @HostListener('input')
  public onChange(): void {
    this.applyMask(this.getClearValue(this.getValue()));
  }

  @HostListener('keypress', ['$event'])
  public onKeyPress(event): void {
    const cursorPosition = this.getCursorPosition();
    let regexp = this.createRegExp(cursorPosition);
    if (regexp != null && !regexp.test(event.key) || this.getValue().length >= this.trInputMask.length) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  public onKeyDown(event): void {
    const key = event.keyCode || event.charCode;
    if ((key == 8 || key == 46) && this.getClearValue(this.getValue()).length === 1) {
      this.setValue('');
      this.state.value = '';
      this.ngModelChange.emit('');
    }
  }

  public ngOnInit(): void {
    this.applyMask(this.getClearValue(this.getValue()));
  }

  private applyMask(value): void {
    let newValue = '';
    let maskPosition = 0;

    if (this.getClearValue(value).length > this.getClearValue(this.trInputMask).length) {
      this.setValue(this.state.value);
      return;
    }

    for (let i = 0; i < value.length; i++) {
      let current = value[i];

      let regexp = this.createRegExp(maskPosition);
      if (regexp != null) {
        if (!regexp.test(current)) {
          this.setValue(this.state.value);
          break;
        }
        newValue += current;
      } else if (this.trInputMask[maskPosition] === current) {
        newValue += current;
      } else {
        newValue += this.trInputMask[maskPosition];
        i--;
      }

      maskPosition++;
    }

    const nextMaskElement = this.trInputMask[maskPosition];
    if (value.length && nextMaskElement != null && /^[-\/\\^$#&@№:<>_\^!*+?.()|\[\]{}]/.test(nextMaskElement)) {
      newValue += nextMaskElement;
    }

    const oldValue = this.state.value;
    const cursorPosition = this.getCursorPosition();
    this.setValue(newValue);
    this.state.value = newValue;

    if (oldValue.length >= cursorPosition) {
      this.setCursorPosition(cursorPosition);
    }

  }

  private createRegExp(position): RegExp | null {
    if (this.trInputMask[position] == null) {
      return null;
    }

    const currentSymbol = this.trInputMask[position].toUpperCase();
    const keys = Object.keys(placeholders);
    const searchPosition = keys.indexOf(currentSymbol);
    if (searchPosition >= 0) {
      return new RegExp(placeholders[keys[searchPosition]], 'gi');
    }
    return null;
  }

  private getValue(): string {
    return this.element.nativeElement.value;
  }

  private getClearValue(value): string {
    return value.trim().replace(/[-\/\\^$#&@№:<>_\^!*+?.()|\[\]{}]/gi, '');
  }

  private setValue(value: string): void {
    this.element.nativeElement.value = value;
  }

  private getCursorPosition(): number {
    return this.element.nativeElement.selectionStart;
  }

  private setCursorPosition(start: number, end: number = start): void {
    this.element.nativeElement.setSelectionRange(start, end);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/input-mask.directive.ts